// src/components/PageHeader.js
import React from "react";

function ActionHeader({ actionTitle }) {
  return (
      <div className="section-header text-center mb-2 mt-2">
        <h3 
          className="fw-bold d-inline-flex align-items-center"        
          style={{
            color: "#012459ff",
            letterSpacing: "0.5px",
          }}
        >
          <i className="bi bi-plus-circle me-2"></i> {actionTitle}
        </h3>
        <hr className="mx-auto" style={{ width: "300px", borderTop: "2px solid #012459ff", opacity: "0.7" }} />
      </div>
  );
}

export default ActionHeader;


